import PersonPersonRelationship from '@/types/personPersonRelationship';
import { OptionType } from '@/ui/components/Form/Select/types';

const formatPersonRelationshipToSelectOption = (
  relationship: PersonPersonRelationship
): OptionType<string> => {
  if (!relationship || !relationship.id) {
    return { label: '', value: '' };
  }

  const { related_person, relationship_type } = relationship;

  if (!related_person || !relationship_type) {
    return { label: '', value: '' };
  }

  const personName = `${related_person.first_name} ${related_person.last_name}`.trim();
  const label = `${personName} (${relationship_type.name})`;

  return {
    label,
    value: related_person.id
  };
};

export default formatPersonRelationshipToSelectOption;
